import { createEvoClient, fetchInvoice, sanitizeBaseUrl } from "@jti/evo-client";
import { getConfig, type InvoiceLink } from "@jti/fe-common";

import { getUser } from "../../../../utils";
import type { CasInvoiceApiContract } from "../CasInvoiceApi.types";

export class CasInvoiceApiEvo implements CasInvoiceApiContract {
  private client;
  private static instance: CasInvoiceApiEvo | null = null;
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected recaptchaId: string,
    protected ciamToken: string,
    protected userUuid: string
  ) {
    this.client = createEvoClient({
      baseUrl: sanitizeBaseUrl(baseUrl),
      ciamToken,
      recaptchaId,
      tenantToken,
      throwOnError: true,
    });
  }

  static init() {
    if (!this.instance) {
      const config = getConfig();
      const user = getUser();
      this.instance = new CasInvoiceApiEvo(
        config.EVO_DOMAIN,
        config.EVO_TENANT,
        config["X-RECAPTCHA-ID"],
        user.ciam_token,
        user.uuid ?? ""
      );
    }
    return this.instance;
  }

  async getInvoicePdf(id: string): Promise<InvoiceLink> {
    const { data } = await fetchInvoice({
      client: this.client,
      path: {
        orderId: id as unknown as number,
        uuid: this.userUuid,
      },
    });
    return {
      url: data?.url,
    };
  }
}
